<template src="./ExternalLayout.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import logo from "@/assets/img/BMWGroup_BMW_MINI_Grey-Colour_RGB.png";

export default defineComponent({
    data() {
        return {
            logo
        };
    }
});
</script>

<style src="./ExternalLayout.scss" lang="scss" scoped></style>
